import { toEDNString } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { SettingUserData, UserSettingsResponse } from "../types/setting";

export const setSetting: (config: SettingUserData) => Promise<any> = async ({
  user,
  key,
  value,
}) => {
  const ednString = toEDNString({
    map: [
      ["user", user],
      ["key", key],
      ["value", value],
    ],
  });
  const query = `
        (datastore Qo.Public.Api.Setting "omega/query-omega/public/api/setting")
        (Qo.Public.Api.Setting/set-setting ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const getUserSettings: (config: {
  user: string;
}) => Promise<UserSettingsResponse> = async ({ user }) => {
  const ednString = toEDNString({
    map: [["user", user]],
  });
  const query = `
        (datastore Qo.Public.Api.Setting "omega/query-omega/public/api/setting")
        (Qo.Public.Api.Setting/user-settings ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
